export default __webpack_public_path__ + "static/media/I_WANNA_DRAW_DEATH_HARPIES.83003417.png";